import { createSlice } from '@reduxjs/toolkit';

export type Team = {
  created_at: string;
  email: string;
  invitedBy: string;
  name: string;
  projectId: string;
  mobile: string;
  role: string;
  status: string;
  updated_at: string;
  userId: string;
  id: string;
  doerType?: string;
};

export type SubTask = {
  name: string;
  tasks: { name: string }[];
};

export type Task = {
  name: string;
  subtasks: SubTask[];
};

export type ProjectInfo = {
  category: string;
  id?: string;
  location: string;
  projectId: string;
  projectImg: string;
  projectName: string;
};

export type Project = {
  documents: string[];
  isDraft: boolean;
  isLaunched: boolean;
  role: string;
  tasks: Task[];
  team: Team[];
  checklistLibraryId: string;
  projectInfo: ProjectInfo;
  inspectionsCount?: number;
  observationsCount?: number;
  incidentsCount?: number;
  created_at: string;
  updated_at: string;
};

export type ProjectNotification = {
  userId: string;
  created_at: string;
  updated_at: string;
  hasRead: boolean;
};

export interface ProjectInitialStates {
  role: string;
  showDropdown: boolean;
  headerTitle: {
    title: string;
    subTitle?: string;
  } | null;
  projects: Project[];
  fetchInProgress: boolean;
  projectFetched: boolean;
  showTasksMenu: boolean;
  notifications: {
    data: ProjectNotification[];
    pagination: {
      page: number;
      totalPage: number;
    };
  };
  unreadNotifications: number;
  dashboardProject: (Project & { id: string; name: string }) | null;
}

const initialState: ProjectInitialStates = {
  role: '',
  showDropdown: false,
  showTasksMenu: false,
  headerTitle: null,
  projects: [],
  fetchInProgress: false,
  projectFetched: false,
  notifications: {
    data: [],
    pagination: {
      page: 1,
      totalPage: 0,
    },
  },
  unreadNotifications: 0,
  dashboardProject: null,
};

const projectSlice = createSlice({
  name: 'projectSlice',
  initialState,
  reducers: {
    showDropdown: (state, { payload }) => {
      state.showDropdown = payload;
    },
    setHeaderTitle: (state, { payload }) => {
      state.headerTitle = payload;
    },
    projectUserRole: (state, { payload }) => {
      state.role = payload;
    },
    setFetchProjectsInProgress: (state) => {
      state.fetchInProgress = true;
      state.projectFetched = false;
    },
    saveProjects: (state, { payload }) => {
      state.projects = payload;
      state.fetchInProgress = false;
      state.projectFetched = true;
    },
    setNotifications: (state, { payload }) => {
      state.notifications = payload;
    },
    setUnreadNotifications: (state, { payload }) => {
      state.unreadNotifications = payload;
    },
    setDashboardProject: (state, { payload }) => {
      if (payload) {
        state.dashboardProject = {
          ...payload,
          id: payload.projectInfo.projectId,
          name: payload.projectInfo.projectName,
        };
      } else {
        state.dashboardProject = payload;
      }
    },
  },
});

export const {
  showDropdown,
  projectUserRole,
  saveProjects,
  setFetchProjectsInProgress,
  setHeaderTitle,
  setNotifications,
  setUnreadNotifications,
  setDashboardProject,
} = projectSlice.actions;
export default projectSlice.reducer;
